declare global {
  interface Window {
    location: Location;
  }
}

const spaUrlChanged = (handler: () => void) => {
  let oldUrl = window.location.href;
  let intervalID = setInterval(function () {
    let curUrl = window.location.href;
    if (oldUrl !== curUrl) {
      oldUrl = curUrl;
      handler();
    }
  }, 500);
  return intervalID;
};

export default spaUrlChanged;
